import { isTestEnvironment } from "shared/utils/checkEnvironment";

const storageURL = isTestEnvironment()
  ? "https://storage.googleapis.com/gewoongers-staging/assets/profile_colors/"
  : "https://storage.googleapis.com/gewoongers-production/assets/profile_colors/";

export function useProfielImage({
  layoutCode,
  colorCode,
}: {
  layoutCode?: string;
  colorCode?: string;
}) {
  //Alt text for the image
  const alt = (layoutCode ?? "") + (colorCode ?? "");

  // Uppercase layout code
  const uppercaseLayoutCode = layoutCode?.toUpperCase() ?? "";

  const generatedColorCode = colorCode?.replace("-profiel", "") ?? "";
  // ImageID generation
  // Format: https://storage.googleapis.com/gewoongers-production/assets/profile_colors/black/e01_black.jpg
  const imageId =
    storageURL +
    generatedColorCode +
    "/" +
    uppercaseLayoutCode +
    "_" +
    generatedColorCode +
    ".jpg";

  //Additional function to generate image ID for dynamic layoutCodes
  const generateImageId = (layoutCode: string, colorCode: string) => {
    const generatedColorCode = colorCode?.replace("-profiel", "") ?? "";
    return (
      storageURL +
      generatedColorCode +
      "/" +
      layoutCode?.toUpperCase() +
      "_" +
      generatedColorCode +
      ".jpg"
    );
  };

  return {
    alt,
    imageId,
    generateImageId,
  };
}
